import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/admission-inquiry";

export const Route = createFileRoute("/admin/_admissions/admission-inquiry")({
  component: Page,
});
